import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../../../atoms/Icon'

function PageButton ({ iconStart, iconEnd, children, disabled, onClick }) {
  const handleClick = useCallback((e) => {
    if (!disabled) {
      onClick(e)
    }
  }, [disabled, onClick])

  const cn = clsx('flex flex-row items-center gap-xs py-1 px-0 select-none radius-xs opal-surface-default', {
    disabled: disabled,
    clickable: !disabled
  })

  return (
    <div role='button' className={cn} onClick={handleClick}>
      {iconStart ? (<Icon name={iconStart} />) : null}
      {children}
      {iconEnd ? (<Icon name={iconEnd} />) : null}
    </div>
  )
}

PageButton.propTypes = {
  children: PropTypes.node,
  iconStart: PropTypes.string,
  iconEnd: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

function Paging ({
  pagingInfo,
  canNext,
  canPrev,
  onNext,
  onPrev
}) {
  if (!pagingInfo) return null

  return (
    <div className='og-paging'>
      <div className='flex flex-row justify-between items-center'>
        <div>
          Showing: <strong>{pagingInfo.start}</strong> - <strong>{pagingInfo.end}</strong> of <strong>{pagingInfo.total}</strong>
        </div>
        <div className='flex flex-row gap-sm'>
          <PageButton
            iconStart='chevronLeft'
            disabled={!canPrev}
            onClick={onPrev}
          >
            Prev
          </PageButton>
          <PageButton
            iconEnd='chevronRight'
            disabled={!canNext}
            onClick={onNext}
          >
            Next
          </PageButton>
        </div>
      </div>
    </div>
  )
}

Paging.propTypes = {
  pagingInfo: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    total: PropTypes.number
  }),
  canNext: PropTypes.bool.isRequired,
  canPrev: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired
}

export default Paging
